<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-card class="ma-2 bg-grey" v-on="on" outlined height="142">
        <v-container style="width:142px" fill-height fluid>
          <v-layout>
            <v-icon class="mx-auto" color="primary">add_a_photo</v-icon>
          </v-layout>
        </v-container>
      </v-card>
      <!-- <v-btn block outlined v-on="on">
        {{$t('addpicture')}}
        <v-icon class="ml-2" color="primary">add_a_photo</v-icon>
      </v-btn>-->
    </template>
    <v-card v-if="dialog">
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("camera")}}</v-tab>
        <v-tab-item>
          <v-layout class="container" column>
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="text-center">
                <input
                accept=".jpg, .png"
                 @change="setImage2" type="file" id="fileInput" />
                <label for="fileInput">
                  <div>
                    <canvas class="d-none" v-show="image" ref="prev"></canvas>
                    <v-img contain height="350" v-if="image" :src="image"></v-img>
                    <v-icon v-if="!image" large color="primary">add_a_photo</v-icon>
                    <a v-else class="primary--text mt-2">{{$t('changeImage')}}</a>
                  </div>
                </label>
                <!-- <image-uploader
                  :preview="false"
                  :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                  :debug="1"
                  :quality="0.8"
                  accept=".jpg, .png"
                  :autoRotate="true"
                  outputFormat="verbose"
                  @input="setImage"
                  @onUpload="loading = true"
                  @onComplete="loading= false"
                >
                  <label for="fileInput" slot="upload-label">
                    <div>
                      <canvas class="d-none" v-show="image" ref="prev"></canvas>
                      <v-img contain height="350" v-if="image" :src="image.dataUrl"></v-img>
                      <v-icon v-if="!image" large color="primary">add_a_photo</v-icon>
                      <a v-else class="primary--text mt-2">{{$t('changeImage')}}</a>
                    </div>
                  </label>
                </image-uploader> -->
                <v-btn class="mt-2" color="primary" icon v-show="image" @click="rotate">
                  <v-icon>crop_rotate</v-icon>
                </v-btn>
              </div>
              <loading v-if="loading"></loading>
              <v-radio-group v-model="approved" row class="justify-center">
                <v-radio color="primary" v-bind:label="$t('approved')" :value="true"></v-radio>
                <v-radio color="primary" v-bind:label="$t('broken')" :value="false"></v-radio>
              </v-radio-group>
            </v-form>
          </v-layout>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn
          color="primary"
          :disabled="image == null || approved == null ? true: false"
          text
          @click="onUpload"
        >{{$t('add')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import uuid from "uuid";

export default {
  name: "AddAttachment",
  components: {},
  props: {
    markerXSolution: Object,
  },
  data() {
    return {
      loading: false,
      valid: true,
      dialog: false,
      approved: null,
      hasImage: false,
      image: null,
      name: '',
    };
  },
  methods: {
    setImage2(input) {
      if (input.target.files.length) {
        this.name = input.target.files[0].name
        var reader = new FileReader();
        reader.onload = (e) => {
         this.image = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]); // convert to base64 string
      }
    },
    setImage: function (output) {
      this.hasImage = true;
      this.image = output;
      const canvas = this.$refs.prev;
      let ctx = canvas.getContext("2d");
      let image = new Image();

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.drawImage(image, image.width / -2, image.height / -2);
        this.$forceUpdate();
      };
      image.src = this.image.dataUrl;
    },
    rotate() {
      this.rotateFunction(this.image, 90, (resultBase64) => {
        this.image = resultBase64;
        this.$forceUpdate();
      });
    },
    rotateFunction(srcBase64, degrees, callback) {
      const canvas = this.$refs.prev;
      let ctx = canvas.getContext("2d");
      let image = new Image();

      image.onload = function () {
        canvas.width = degrees % 180 === 0 ? image.width : image.height;
        canvas.height = degrees % 180 === 0 ? image.height : image.width;

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((degrees * Math.PI) / 180);
        ctx.drawImage(image, image.width / -2, image.height / -2);

        callback(canvas.toDataURL());
      };

      image.src = srcBase64;
    },
    onUpload() {
      if (this.image != null) {
        if (this.$refs.form.validate()) {
          var date = new Date();
          const attachment = {
            id: uuid.v4(),
            markerId: this.$route.params.id,
            markerXSolutionsId: this.markerXSolution.id,
            name: this.name,
            content: this.image,
            approved: this.approved,
            createdBy: localStorage.getItem("user"),
            createdTs: date.toJSON(),
            new: true,
          };
          if (this.$store.state.isOffline) {
            this.$emit("add-picture", attachment);
            this.$store.state.hasChanges = true;
            this.close();
            this.image = null;
            this.approved = null;
          } else {
            //if (this.markerXSolution.new) {
            this.$emit("add-picture", attachment);
            this.$store.state.hasChanges = true;
            this.close();
            this.image = null;
            this.approved = null;
          }
        }
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>


<style>
#fileInput {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/AddAttachment.vue